<router-outlet></router-outlet>
<p-toast
    [key]="TOAST_KEY"
    position="bottom-center"
    [preventOpenDuplicates]="true">
</p-toast>
<!-- Client generic error toast should be available at multiple locations -client-registration, password setting, client portal, ...
 Placing it here so that we limit the number of occurrences -->
<apcam-error-toast-generic></apcam-error-toast-generic>
<p-confirmDialog [key]="CAN_DEACTIVATE_CONFIRM_KEY" />
